import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import Bannerfrom from "../components/bannerfrom";
import {Link} from 'gatsby';

function Banner(props) {
    return (
        <div className="services_location_banner">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={6} xl={7} xxl={7} className="my-auto">
                        <div className="banenr_content">
                            <div className="example" data-text="New York">
                                <h1>Software Development Company in <span>New York</span></h1>
                            </div>
                            <p className="main_para">Revamp your business processes with our all-in-one SaaS solutions and premium mobile and web applications. As a renowned software development company in New York, we're dedicated to design user experiences for your customers that align seamlessly with their brand values, accelerating your pathway to achieving business objectives 2x faster!</p>
                            <Link to="/contact"
                            className="border_btn" aria-label="TekRevol Contact"> Let’s Get Started</Link>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={5} xxl={5} className="my-auto">
                        <Bannerfrom/>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Banner;